var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.579 14.806 4.702-2.632 4.701 2.632-1.05-5.286 3.957-3.658-5.351-.635L8.28.333 6.023 5.227l-5.351.635L4.629 9.52l-1.05 5.286Z",
    fill: "#555249"
  })));
};

export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjU3ODU0IDE0LjgwNTVMOC4yODA1NCAxMi4xNzM1TDEyLjk4MjUgMTQuODA1NUwxMS45MzI1IDkuNTIwMTZMMTUuODg5MiA1Ljg2MTVMMTAuNTM3OSA1LjIyNjgzTDguMjgwNTQgMC4zMzM0OTZMNi4wMjMyMSA1LjIyNjgzTDAuNjcxODc1IDUuODYxNUw0LjYyODU0IDkuNTIwMTZMMy41Nzg1NCAxNC44MDU1WiIgZmlsbD0iIzU1NTI0OSIvPgo8L3N2Zz4K";